<template>
    <div>

        <b-button variant="btn btn-primary" v-b-modal.lista_iscritti>{{$t('athlete_list.cta')}}</b-button>

        <b-modal id="lista_iscritti" :title="$t('athlete_list.title')" size="xl" centered hide-footer @show="onShow">
            <div class="container race-detail-wrapper" v-if="hasResults">
                <div class="col-12">
                    <div class="p-4 rounded bg-orange">
                        <div class="row">
                            <div class="col-lg-4" v-if="opt_events.length > 1">
                                <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.event')}}</label>
                                <b-form-select v-model="classifica.event" :options="opt_events"
                                               @change="updateClassifica"></b-form-select>
                            </div>
                            <div class="col">
                                <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.gender')}}</label>
                                <b-form-select v-model="classifica.sesso" :options="opt_sex"
                                               @change="updateClassifica"></b-form-select>
                            </div>
                            <div class="col">
                                <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.country')}}</label>
                                <b-form-select v-model="classifica.country" :options="opt_country"
                                               @change="updateClassifica"></b-form-select>
                            </div>
                            <div class="col">
                                <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.age_group')}}</label>
                                <b-form-select v-model="classifica.agegroup" :options="opt_agegroup"
                                               @change="updateClassifica"></b-form-select>
                            </div>
                            <div class="col-12 mt-1 mt-lg-3">
                                <label class="text-uppercase small text-white pl-2">
                                    {{$t('banner_filter.free_search')}}
                                    <span class="small text-white mt-1 pr-2 text-right" style="visibility: hidden;"
                                          :class="{'show-help-text': classifica.testo.length <= 2 && classifica.testo.length > 0}">
                            {{$t('search_box.help_text_min_characters')}}
                        </span>
                                </label>
                                <b-form-input v-model="classifica.testo" :placeholder="$t('placeholder_ricerca')"
                                              @input="updateTextClassifica"></b-form-input>

                            </div>
                        </div>
                    </div>

                    <div class="col mt-4">
                        <div class="row text-center text-uppercase bg-light small">
                            <div class="col d-flex align-items-center justify-content-center py-3 border-bottom order-7 order-lg-4">
                                {{$t('charts_head.bib_number')}}
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-start text-left py-3 border-bottom order-2 order-lg-5">
                                <div>{{$t('charts_head.name_surname')}}<span class="d-block font-weight-bold">{{$t('charts_head.team')}}</span>
                                </div>
                            </div>
                            <div class="col d-flex align-items-center justify-content-center py-3 border-bottom order-8 order-lg-6">
                                {{$t('charts_head.country')}}
                            </div>
                            <div class="col d-flex align-items-center justify-content-center py-3 border-bottom order-9 order-lg-7">
                                {{$t('charts_head.age_group')}}
                            </div>
                        </div>
                        <div class="row small" v-for="atl in classifica.data" :key="atl.BibNumber">
                            <div class="col d-flex align-items-center justify-content-center py-2 border-bottom order-7 order-lg-4">
                                {{atl.BibString}}
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-start  py-2 border-bottom order-2 order-lg-5 bg-light">
                                <div class="d-lg-flex align-items-center justify-content-between w-100">
                                    <div>
                                        <div>{{atl.Name}} {{atl.Surname}}
                                            <div class="font-weight-bold">{{atl.ClubName}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="country-flag col d-flex align-items-center justify-content-center py-2 border-bottom order-9 order-lg-7">
                                <img :src="`${publicPath}flags/${atl.Country}.gif`"
                                     :alt="atl.Country" v-if="atl.Country"
                                     v-b-tooltip.hover :title="atl.Country">
                            </div>


                            <!--<div class="col d-flex align-items-center justify-content-center py-2 border-bottom order-8 order-lg-6">{{atl.Country}}</div>-->
                            <div class="col d-flex align-items-center justify-content-center py-2 border-bottom order-9 order-lg-7">
                                {{atl.AgeGroup}}
                            </div>
                        </div>
                    </div>
                    <div v-if="(classifica.tot > classifica.numPerPage)">
                        <b-pagination class="justify-content-center" :total-rows=Number(classifica.tot)
                                      v-model="classifica.pag" :per-page="classifica.numPerPage"
                                      @change="getClassifica"></b-pagination>
                        <div class="col-md-12 text-center text-muted mt-1">
                            <!--{{classifica.data.length}} {{$t('of')}}-->
                            {{classifica.tot}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce'
    import BaseVue from '../views/BaseVue'

    export default {
        extends: BaseVue,
        name: 'ListaIscritti',
        props: ['id', 'data'],
        data() {
            return {
                publicPath: process.env.BASE_URL,
                loaded: false,
                hasResults: false,
                classifica: {
                    data: [],
                    pag: 1,
                    tot: 0,
                    numPerPage: 20,
                    event: -1,
                    sesso: -1,
                    agegroup: -1,
                    country: -1,
                    split: 0,
                    testo: '',
                    opts: {
                        agegroup: [],
                        country: [],
                        sex: []
                    },
                    md5url: '',
                    md5search: '',
                    id: 0
                },
            }
        },
        methods: {
            async onShow() {

                this.loaded = false

                for (let i = 0; i < this.data.Events.length; i++) {
                    if (this.data.Events[i].IsDefault) {
                        let ev = this.data.Events[i]
                        this.classifica.event = ev.ID

                        for (let j = 0; j < ev.RaceSplits.length; j++) {
                            if (ev.RaceSplits[j].IsDefault) {
                                this.classifica.split = ev.RaceSplits[j].ID
                                break;
                            }
                        }

                        break;
                    }
                }

                await this.$nextTick()

                this.classifica.pag = 1
                await this.getClassifica(this.classifica.pag)
                this.loaded = true

            }, async updateClassifica() {
                await this.$nextTick()
                this.classifica.pag = 1
                this.getClassifica(this.classifica.pag)
            }, updateTextClassifica: debounce(function () {
                this.updateClassifica()
            }, 1000), async getClassifica(pag) {
                let url = this.id + '/entries/' + this.classifica.event

                if (this.classifica.testo.length > 2) url += '/filter/' + encodeURIComponent(this.classifica.testo)

                if (this.classifica.sesso !== -1) url += '/s/' + this.classifica.sesso
                if (this.classifica.agegroup !== -1) url += '/a/' + this.classifica.agegroup
                if (this.classifica.country !== -1) url += '/c/' + this.classifica.country

                url += '/' + ((pag - 1) * this.classifica.numPerPage + 1) + '/' + this.classifica.numPerPage // Paginazione

                if (this.classifica.md5search === url) return
                this.classifica.md5search = url

                let result = await this.get(url, true)


                this.classifica.data = result.Athletes
                this.classifica.tot = result.Status.RecordCount
                this.hasResults = true


                let md5url = this.makeUrl(this.classifica.sesso, this.classifica.agegroup, this.classifica.country)
                // Se non è cambiato nulla come parametri, non rieffettuo la ricerca dei valori
                if (md5url === this.classifica.md5url) return
                this.classifica.md5url = md5url

                // Faccio il fetch dei valori di agegroup,country e sex
                let data = await this.get([
                    this.makeUrl(this.classifica.sesso, -1, this.classifica.country) + '/agegroup',
                    this.makeUrl(this.classifica.sesso, this.classifica.agegroup, -1) + '/country',
                    this.makeUrl(-1, this.classifica.agegroup, this.classifica.country) + '/sex',
                ])

                // Li salvo nei data, da cui verranno poi presi e rielaborati per generare i computed
                this.classifica.opts.agegroup = data[0].ValuesCounters
                this.classifica.opts.country = data[1].ValuesCounters
                this.classifica.opts.sex = data[2].ValuesCounters

            }, makeUrl(sesso, agegroup, country) {
                let url = this.id + '/' + this.classifica.event + '/list' // Punto di controllo, es: Arrivo
                if (sesso !== -1) url += '/s/' + sesso
                if (agegroup !== -1) url += '/a/' + agegroup
                if (country !== -1) url += ''

                return url
            }, optsFromValue(values, empty) {
                if (empty === undefined) empty = ' - '

                if (values.length <= 0) return [{value: -1, text: ' - '}]
                let opts = []
                opts.push({value: -1, text: empty})
                for (let i = 0; i < values.length; i++)
                    opts.push({
                        value: values[i].Description,
                        text: values[i].Description + ' (' + values[i].Count + ')'
                    })
                return opts
            }
        }, computed: {
            events() {
                let events = []
                for (let i = 0; i < this.data.Events.length; i++) {
                    if (this.data.Events[i].Enabled)
                        events.push(this.data.Events[i])
                }
                return events
            }, event() {
                if (this.events.length <= 0) return {}
                for (let i = 0; i < this.events.length; i++)
                    if (this.events[i].ID === this.classifica.event) {
                        let ev = this.events[i]
                        if (this.old_ev !== ev.ID) {
                            // eslint-disable-next-line
                            this.old_ev = ev.ID
                            // eslint-disable-next-line
                            this.classifica.split = 0
                            // eslint-disable-next-line
                            setTimeout(() => {
                                this.eventChanged()
                            }, 10)
                        }
                        return ev
                    }
                return {}
            },
            opt_events() {
                let opts = []
                for (let i = 0; i < this.events.length; i++)
                    opts.push({value: this.events[i].ID, text: this.events[i].Name})
                return opts
            }, opt_sex() {
                let opts = this.optsFromValue(this.classifica.opts.sex, this.$t('default.sex'))
                for (let i = 0; i < opts.length; i++) {
                    let opt = opts[i]
                    if ((opt.value === 'M') || (opt.value === 'F')) {
                        opt.text = this.$t('sesso.' + opt.value) + opt.text.substr(1) // this.$t.translate('')
                    }
                }
                return opts
            }, opt_agegroup() {
                return this.optsFromValue(this.classifica.opts.agegroup, this.$t('default.agegroup'))
            }, opt_country() {
                return this.optsFromValue(this.classifica.opts.country, this.$t('default.country'))
            }
        }
    }
</script>

<style scoped>

</style>
